/* esm.sh - highlight.js@11.11.1/lib/languages/erb */
function n(e){return{name:"ERB",subLanguage:"xml",contains:[e.COMMENT("<%#","%>"),{begin:"<%[%=-]?",end:"[%-]?%>",subLanguage:"ruby",excludeBegin:!0,excludeEnd:!0}]}}export{n as default};
//# sourceMappingURL=erb.mjs.map